import { ApiResponse } from '@/modules/common/types/dto/response/api-response';
import { PaginatedResponse } from '@/modules/common/types/pagination-types';
import { BaseOnboardingEntity } from '@/modules/onboarding/common/types/base-onboarding-entity';
import { TeamMemberInvitationStatusDTO } from '@/modules/team/types/dto/team-member-invitation-status.dto';

export enum TeamDataReconciliationQueryKeys {
  TeamMembers = 'team-members-data-reconciliation',
  ValidationReport = 'team-members-validation-report',
}

export interface Employee extends BaseOnboardingEntity {
  email: string | null;
  isChampion: boolean;
  invitationStatus: TeamMemberInvitationStatusDTO;
}

export interface EmployeesApiData extends PaginatedResponse<Employee> {}

export class EmployeesApiResponse extends ApiResponse<EmployeesApiData> {}
